export default "__VITE_ASSET__e1a634d5__"